export const APIGEE_BASE_URL =
  process.env.APIGEE_BASE_URL || "https://api-test.retailsso.com";

export const FEATURE_FLAG_BASE_URL =
  process.env.FEATURE_FLAG__K8S_BASE_URL ?? "";

export const IMAGE_BASE_URL =
  process.env.NEXT_PUBLIC_CDN_BASE_URL || "https://cdnprod.mafretailproxy.com";

/**
 * Base URLs for backend services
 */

export const ADTECH_BASE_URL = process.env.ADTECH__K8S_BASE_URL ?? "";

export const BASKET_BASE_URL = process.env.BASKET__K8S_BASE_URL ?? "";

export const FRAME_BASE_URL = process.env.FRAME__K8S_BASE_URL ?? "";

export const HOME_BFF_BASE_URL = process.env.HOME_BFF__K8S_BASE_URL ?? "";

export const ORDER_BFF_BASE_URL = process.env.ORDER_BFF__K8S_BASE_URL ?? "";

export const PDP_BFF_BASE_URL = process.env.PDP_BFF__K8S_BASE_URL ?? "";

export const SEARCH_BASE_URL = process.env.SEARCH__K8S_BASE_URL ?? "";
